import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import MenuIcon from '@mui/icons-material/Menu';
import HelpIcon from '@mui/icons-material/Help';
import { Avatar, Box, Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import weldingo from '../images/white_logo_transparent.png';
import SupportModal from './SupportModal';

export default function AppMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [screenShotFileData, setScreenShotFileData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const email = localStorage.getItem('email');
  const projectId = useParams().projectId
  const elementId = useParams().elementId
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleBack = () => {
    switch (location.pathname.match(/\/\w+/)[0]) {
      case '/project':
        navigate('/project-list');
        break;
      case '/welds':
        navigate(`/project/${Number(projectId)}`);
        break;
      case '/inspection':
        navigate(`/welds/${Number(projectId)}/${Number(elementId)}`);
        break;
      case '/welding':
        navigate(`/welds/${Number(projectId)}/${Number(elementId)}`);
        break;
      default:
        navigate(`/ `);
    }
  };


  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/';
  };

  const handleSupportClick = () => {
    html2canvas(document.body, {
      useCORS: true,
      allowTaint: true,
      scale: 0.5
    }).then(canvas => {
      const dataURL = canvas.toDataURL('image/jpeg', 0.8)
      setScreenShotFileData(dataURL)
      setShowSupportModal(true)
    }).catch(error => {
      console.error('Error capturing screenshot:', error)
      setScreenShotFileData('data:image/jpeg;base64,')
      setShowSupportModal(true)
    })
  }

  const handleCloseSupportModal = () => {
    setShowSupportModal(false)
    setScreenShotFileData(null)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 16px',
          backgroundColor: 'primary.main',
          color: 'white',
        }}
      >
        {location.pathname !== 'project-list' && (
          <IconButton onClick={handleBack} color="inherit">
            <KeyboardBackspaceIcon />
          </IconButton>
        )}
        <a href="/" rel="noopener noreferrer">
          <img
            src={weldingo}
            alt="Weldingo"
            style={{ height: '80px' }}
          />
        </a>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton color="inherit" onClick={handleSupportClick}>
            <HelpIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleMenuOpen}>
            <MenuIcon />
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {email && (
            <MenuItem>
              <Avatar sx={{ marginRight: 1 }}>{email[0].toUpperCase()}</Avatar>
              <Typography>{email}</Typography>
            </MenuItem>
          )}
          <hr></hr>
          <MenuItem onClick={handleLogout}>
            <Button variant="text" color="inherit">Logout</Button>
          </MenuItem>
        </Menu>
      </Box>
      
      {showSupportModal && (
        <SupportModal
          onCancel={handleCloseSupportModal}
          screenShotFileData={screenShotFileData}
        />
      )}
    </>
  );
}
